export const enum SurveyType {
  Pre,
  Post,
  Ticket,
  Custom,
}
